export const SET_IMAGE_DATA = 'image/SET_IMAGE_DATA'
export const SET_SEARCH_TIME = 'image/SET_SEARCH_TIME'